/* tslint:disable */
/* eslint-disable */
/**
 * Payment API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * チップを修正するリクエスト
 * @export
 * @interface UpdateBillingTipRequest
 */
export interface UpdateBillingTipRequest {
    /**
     * 実績支払方法
     * @type {string}
     * @memberof UpdateBillingTipRequest
     */
    paymentMethod: UpdateBillingTipRequestPaymentMethodEnum | null;
    /**
     * チップ金額
     * @type {number}
     * @memberof UpdateBillingTipRequest
     */
    tipAmount: number;
    /**
     * 変更理由等を記録するメモ（最大100文字）
     * @type {string}
     * @memberof UpdateBillingTipRequest
     */
    note?: string;
}


/**
 * @export
 */
export const UpdateBillingTipRequestPaymentMethodEnum = {
    IN_CAR_PAYMENT: '0',
    APP_PAYMENT_CREDIT_CARD: '1',
    EITHER: '2',
    APP_PAYMENT_APPLE_PAY: '3',
    RINGO_PASS_PAYMENT: '4',
    BACK_SEAT_PAYMENT: '5',
    APP_PAYMENT_CAB_CARD: '6',
    APP_PAYMENT_S_RIDE_BIZ: '7',
    APP_PAY_PAY: '10',
    APP_AU_PAY: '11',
    APP_D_PAY: '12',
    APP_R_PAY: '13',
    DIDI: '14',
    UBER: '15'
} as const;
export type UpdateBillingTipRequestPaymentMethodEnum = typeof UpdateBillingTipRequestPaymentMethodEnum[keyof typeof UpdateBillingTipRequestPaymentMethodEnum];


/**
 * Check if a given object implements the UpdateBillingTipRequest interface.
 */
export function instanceOfUpdateBillingTipRequest(value: object): value is UpdateBillingTipRequest {
    if (!('paymentMethod' in value) || value['paymentMethod'] === undefined) return false;
    if (!('tipAmount' in value) || value['tipAmount'] === undefined) return false;
    return true;
}

export function UpdateBillingTipRequestFromJSON(json: any): UpdateBillingTipRequest {
    return UpdateBillingTipRequestFromJSONTyped(json, false);
}

export function UpdateBillingTipRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateBillingTipRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'paymentMethod': json['payment_method'],
        'tipAmount': json['tip_amount'],
        'note': json['note'] == null ? undefined : json['note'],
    };
}

export function UpdateBillingTipRequestToJSON(json: any): UpdateBillingTipRequest {
    return UpdateBillingTipRequestToJSONTyped(json, false);
}

export function UpdateBillingTipRequestToJSONTyped(value?: UpdateBillingTipRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'payment_method': value['paymentMethod'],
        'tip_amount': value['tipAmount'],
        'note': value['note'],
    };
}

